import * as React from 'react';

import type { PatchedLocationDescriptor } from 'js/lib/connectToRouter';

import type { Item } from 'bundles/author-common/types/Item';
import type SessionItem from 'bundles/author-sessions/models/SessionItem';
import type { ItemGrade } from 'bundles/authoring/common/types/gradebookV2';
import type { ProctorConfig } from 'bundles/authoring/common/types/proctorConfig';
import type { MutationInjectedProps } from 'bundles/grading/api/GradingMutationWrapper';
import type { UseAssignmentInfoQueryResult } from 'bundles/grading/hooks/useAssignmentInfoQuery';
import type { UseSubmissionDataResult } from 'bundles/grading/hooks/useSubmissionDataQuery';
import type { UseSubmissionHeadersResult } from 'bundles/grading/hooks/useSubmissionHeadersQuery';
import type { UseSubmitterListQueryResult } from 'bundles/grading/hooks/useSubmitterListQuery';
import type { ReentryLogManager } from 'bundles/grading/utils/ReentryLogManager';

export type SgaPageData = {
  courseId: string;
  courseBranchId: string;
  currentItem: Item;
  currentItemId: string;
  groupId?: string;
  gradingGroupId?: string;
  currentCourseSlug: string;
  currentContextId: string;
  sessionItem: SessionItem;
  gradebookGrades: { [userId: string]: ItemGrade };
  isAnonymized: boolean;
  proctorConfigDraft: ProctorConfig;
};

/**
 * Callback function type to get the appropriate URLs for changing submitter/question/rubric
 */
export type GetUrlFn = (
  submitterId: string,
  questionId?: string,
  rubricId?: string,
  lastPart?: boolean
) => PatchedLocationDescriptor;

export type SGAPageContextType = {
  isPrivateSession: boolean;
  pageData: SgaPageData;
  submissionHeaders: UseSubmissionHeadersResult;
  submitterList: UseSubmitterListQueryResult;
  submissionData: UseSubmissionDataResult;
  assignmentInfo: UseAssignmentInfoQueryResult;
  getUrl: GetUrlFn;
  reentryLog: ReentryLogManager;
  mutations?: MutationInjectedProps;
};

export const SGAPageContext = React.createContext({} as SGAPageContextType);
